import { useMemo } from 'react';
import { useResponsive } from 'app/hooks';
import { MediaFileProps } from '../media-file.types';
import { VStack, Text } from 'app/pages/request-single-page/components-v4';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';
import { OtherWrapper } from '../media-file.styled';

export const Other = ({
  file,
  mode,
  textForOtherFile,
}: Pick<MediaFileProps, 'file' | 'mode' | 'textForOtherFile'>) => {
  const theme = useV4Theme();
  const { viewport } = useResponsive();

  const wrapperBackgroundColor = useMemo(() => {
    if (!viewport.desktop) {
      return 'inherit';
    }

    if (mode === 'preview') {
      return theme.colors.gray[100];
    }

    return theme.colors.gray[400];
  }, [mode, theme.colors.gray, viewport.desktop]);

  const innerBackgroundColor = useMemo(() => {
    if (mode === 'thumbnail') {
      return 'inherit';
    }

    return theme.colors.gray[400];
  }, [mode, theme.colors.gray]);

  return (
    <OtherWrapper
      style={{
        backgroundColor: wrapperBackgroundColor,
      }}
    >
      <VStack
        padding={8}
        align="center"
        justify="center"
        width={mode === 'preview' ? 150 : '100%'}
        height={mode === 'preview' ? 180 : '100%'}
        style={{
          backgroundColor: innerBackgroundColor,
          borderRadius: theme.radiuses.xs,
        }}
      >
        {mode === 'thumbnail' ? (
          <Text variant="heading-4" align="center">
            .{file.extension}
          </Text>
        ) : (
          <VStack align="center" spacing="xxs">
            <Text variant="heading-4">.{file.extension}</Text>
            <Text variant="heading-4" truncate>
              {file.name.replace(`.${file.extension}`, '')}
            </Text>
          </VStack>
        )}
      </VStack>

      {textForOtherFile && (
        <Text
          variant="body-16"
          color={viewport.desktop ? 'gray.500' : undefined}
        >
          {textForOtherFile}
        </Text>
      )}
    </OtherWrapper>
  );
};
